<template>
  <AppPrivate v-if="active" />
  <AppPublic v-else />
  <BlockSpinner v-if="isLoading" />
</template>

<script setup>
import {computed, defineAsyncComponent} from 'vue';
import {useNProgress} from '@vueuse/integrations/useNProgress';
import {useRoute} from 'vue-router';
import {useStore} from 'vuex';

const AppPrivate = defineAsyncComponent(() =>
  import('./views/app/AppPrivate.vue'),
);
const AppPublic = defineAsyncComponent(() =>
  import('./views/app/AppPublic.vue'),
);
const BlockSpinner = defineAsyncComponent(() =>
  import('@/components/componentes-custom/BlockSpinner.vue'),
);


const store = useStore();
const route = useRoute();
const {isLoading} = useNProgress();

store.commit('auth/setTextSpinner', 'Cargando...');
const active = computed(() => {
  return route?.meta.requiresAuthentication;
});
</script>
